// extracted by mini-css-extract-plugin
module.exports = {"main":"Pager_main__3BgV2","page__indicator":"Pager_page__indicator__3K9oj","page__indicator_disabled":"Pager_page__indicator_disabled__3uT_Z"};